<template>
    <ul class="list-group">
        <template v-for="(err,index) in errors">
            <li class="list-group-item" :class="{
                    'bg-light-danger':err.Type == 'NotRegisteredOnSystem', 
                    'bg-light-danger':err.Type == 'NotRegisteredSgk', 
                    'bg-light-danger':err.Type == 'HasNoDriverCard',
                    'bg-light-secondary':err.Type == 'Conflict',
                    'bg-light-secondary':err.Type == 'CantWork',
                    'bg-light-warning':err.Type == 'RepeatEmpty',
                }" :key="index + err.Type">
                <template v-if="err.Type == 'HasNoDriverCard'">
                    Sürücünün dijital ehliyet numarası sistemde kayıtlı değil. (Takograf verileri getirilemedi.)
                </template>
                <template v-if="err.Type == 'NotRegisteredOnSystem'">
                    Sürücü sistemde kayıtlı değil.
                </template>
                <template v-if="err.Type == 'Conflict'">
                    <strong>{{err.DayStart}}</strong> tarihinde tutarsız puantaj kaydı bulunmaktadır.
                </template>
                <template v-if="err.Type == 'CantWork'">
                    <strong>{{err.DayStart}}</strong> tarihinde tackograf kaydı olmasına rağmen günlük puantajı <b>{{ err.Name }}</b> olarak kaydedilmiş.
                </template>
                <template v-if="err.Type == 'RepeatEmpty'">
                    <template v-if="err.DayStart == err.DayEnd">
                        <strong>{{err.DayStart}}</strong> tarihinde puantaj kaydı bulunmamaktadır.
                    </template>
                    <template v-else>
                        <strong>{{err.DayStart}} - {{err.DayEnd}}</strong> tarihleri arasında arka arkaya toplam {{err.Count}} gün puantaj kaydı bulunmamaktadır.
                    </template>
                </template>
                <template v-if="err.Type == 'NotRegisteredSgk'">
                    Personelin seçilen ay <strong>({{month}})</strong> için sgk işe giriş kaydı bulunmamaktadır.
                </template>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props:{
        errors:{
            type:Array,
            default:()=>[]
        },
        month:String
    }
}
</script>

<style>

</style>